import { useState } from "react";

const galleryItems = [
  {
    id: 1,
    tag: "Day 001",
    title: "Green Monday",
    caption: "The last normal day. The first day of war.",
    image:
      "https://public.readdy.ai/ai/img_res/37e4f9f77b1e18b52a0205be3a795796.jpg",
  },
  {
    id: 2,
    tag: "Day 023",
    title: "Home-Run",
    caption: "Barbed wire. Rust. Resolve.",
    image:
      "https://readdy.ai/api/search-image?query=dramatic%20close%20up%20barbed%20wire%20wrapped%20softball%20bat%20resting%20against%20crumbling%20concrete%20wall%2C%20rust%20stains%2C%20dried%20blood%2C%20harsh%20single%20side%20light%2C%20dark%20shadows%2C%20gritty%20macro%20photography%2C%20post-apocalyptic%20weapon%20art%2C%20moody%20cinematic%20still%20life&width=500&height=650&seq=gal002&orientation=portrait",
  },
  {
    id: 3,
    tag: "Day 156",
    title: "Night at the Fortress",
    caption: "When they still had a home.",
    image:
      "https://readdy.ai/api/search-image?query=small%20survivor%20camp%20inside%20dark%20abandoned%20building%2C%20warm%20orange%20campfire%20glow%2C%20makeshift%20tents%20and%20cots%2C%20people%20huddled%20around%20fire%2C%20dark%20night%20outside%20broken%20windows%2C%20post-apocalyptic%20refuge%2C%20intimate%20and%20hopeful%20warm%20light%2C%20cinematic%20photography%2C%20dystopian%20survival%20camp&width=500&height=650&seq=gal003&orientation=portrait",
  },
  {
    id: 4,
    tag: "Day 365",
    title: "The Signal",
    caption: "A voice through static. Everything changed.",
    image:
      "https://readdy.ai/api/search-image?query=old%20abandoned%20ham%20radio%20operator%20station%2C%20vintage%20radio%20equipment%20illuminated%2C%20green%20dial%20glow%2C%20dust%20floating%20in%20single%20shaft%20of%20light%2C%20dark%20wooden%20room%2C%20analog%20meters%20and%20dials%2C%20hope%20and%20mystery%2C%20cinematic%20atmospheric%20photography%2C%20dramatic%20contrast%2C%20radio%20static%20moment&width=500&height=650&seq=gal004&orientation=portrait",
  },
  {
    id: 5,
    tag: "Day 412",
    title: "Into the Wasteland",
    caption: "She doesn't stop. She can't afford to.",
    image:
      "https://readdy.ai/api/search-image?query=lone%20female%20silhouette%20walking%20through%20foggy%20desolate%20wasteland%2C%20ruined%20buildings%20in%20background%2C%20ashen%20gray%20landscape%2C%20overcast%20sky%2C%20backlit%20dramatic%20light%2C%20bat%20in%20hand%2C%20isolated%20powerful%20cinematic%20composition%2C%20dark%20post-apocalyptic%20atmosphere%2C%20gritty%20film%20grain&width=500&height=650&seq=gal005&orientation=portrait",
  },
  {
    id: 6,
    tag: "Day 589",
    title: "The Promise",
    caption: "Every step. Every fight. For him.",
    image:
      "https://readdy.ai/api/search-image?query=abandoned%20hotel%20corridor%20dark%20and%20eerie%2C%20flickering%20fluorescent%20lights%2C%20peeling%20wallpaper%2C%20broken%20furniture%2C%20dust%20and%20debris%2C%20long%20dark%20hallway%20with%20light%20at%20end%2C%20dramatic%20horror%20atmosphere%2C%20cinematic%20photography%2C%20dystopian%20hotel%20interior%2C%20mystery%20and%20hope&width=500&height=650&seq=gal006&orientation=portrait",
  },
];

export default function GallerySection() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const openLightbox = (id: number) => setLightbox(id);
  const closeLightbox = () => setLightbox(null);

  const lightboxItem = galleryItems.find((g) => g.id === lightbox);

  return (
    <section id="gallery" className="w-full bg-[#0A0A0A] py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.3em] uppercase block mb-4">
            [ Field Documentation ]
          </span>
          <h2 className="font-['Special_Elite'] text-white text-4xl md:text-5xl">
            Dispatches from the <span className="text-[#C8922A]">Wasteland</span>
          </h2>
          <p className="font-['Rajdhani'] text-[#666] mt-3 text-sm tracking-wide">
            Click any image to expand
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-3">
          {galleryItems.map((item) => (
            <div
              key={item.id}
              onClick={() => openLightbox(item.id)}
              className="relative group overflow-hidden cursor-pointer"
            >
              <img
                src={item.image}
                alt={`${item.title} – Jordan Reyes wasteland dispatch`}
                className="w-full h-48 sm:h-64 md:h-72 object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              {/* Overlay */}
              <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-widest mb-1">
                  {item.tag}
                </span>
                <h4 className="font-['Special_Elite'] text-white text-lg">{item.title}</h4>
                <p className="font-['Rajdhani'] text-[#AAAAAA] text-xs">{item.caption}</p>
              </div>
              {/* Tag */}
              <div className="absolute top-3 left-3">
                <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs border border-[#C8922A]/50 bg-black/70 px-2 py-1 tracking-widest">
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && lightboxItem && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <div
            className="relative max-w-2xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={lightboxItem.image}
              alt={`${lightboxItem.title} full view`}
              className="w-full max-h-[75vh] object-contain"
            />
            <div className="bg-[#0D0D0D] border border-[#2C2C2C] p-5">
              <div className="flex items-start justify-between">
                <div>
                  <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-widest">
                    {lightboxItem.tag}
                  </span>
                  <h3 className="font-['Special_Elite'] text-white text-2xl mt-1">
                    {lightboxItem.title}
                  </h3>
                  <p className="font-['Rajdhani'] text-[#888] text-sm mt-1">
                    {lightboxItem.caption}
                  </p>
                </div>
                <button
                  onClick={closeLightbox}
                  className="w-8 h-8 flex items-center justify-center text-[#666] hover:text-white cursor-pointer transition-colors"
                >
                  <i className="ri-close-line text-xl" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
